import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { GeonameSecondOrder } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

/**
 * Hook to fetch second-order administrative divisions for a country
 * @param countryCode ISO country code (e.g., 'TW')
 * @param maxRows maximum rows to fetch
 */
export function useSecondOrderDivisions(countryCode: string | null, maxRows?: number) {
  const { token } = useAuth()
  const query = maxRows ? `?maxRows=${maxRows}` : ''
  const url = countryCode ? `/api/geonames/${countryCode}/second-order${query}` : null
  const { data, error, mutate } = useGet<ApiResponse<GeonameSecondOrder[]>>(
    token && url ? url : null,
    undefined,
    token ?? '',
  )

  return {
    divisions: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
